import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import VerificationInputField from "components/VerificationInputField";
import ModalGeneralSuccessfully from "screens/ModalGeneralSuccessfully";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { VERIFY_NEW_CONTACT } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalVerification = ({
  hidden,
  isOpen,
  setClose,
  refetch,
  token,
  email,
  phoneNumber,
  retry
}) => {

  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationCodeError, setVerificationCodeError] = useState(false);

  const [verifyNewContact, { loading, error }] = useMutation(VERIFY_NEW_CONTACT, {
    onCompleted: () => {
      setClose();
      setSuccessfullyIsOpen(true);
      setVerificationCode("");
    },
    onError: () => {
      setClose();
      setFailedIsOpen(true);
    }
  })

  const handleVerify = () => {
    if (verificationCode.length !== 6) {
      setVerificationCodeError(true);
      return;
    }
    if (email) {
    verifyNewContact({
      variables: {
        input: {
          contactType: "EMAIL",
          sessionToken: token,
          code: verificationCode.join(''),
          newValue: email
        },
      },
    });
    } else if(phoneNumber) {
      verifyNewContact({
        variables: {
          input: {
            contactType: "PHONE",
            sessionToken: token,
            code: verificationCode.join(''),
            newValue: phoneNumber
          },
        },
      });
    } else {
      return;
    }
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setClose={setClose}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Confirmation Required</Head>
        <Container>
          <div className="modalText">{`A verification code has been sent to your new ${email? ('email address '+ email): ('phone number ending in '+ phoneNumber?.slice(-4))}. Please enter the code below to confirm your update:`}</div> 
          <VerificationInputField
            label="VERIFICATION CODE"
            isRequired
            width="100%"
            length={6}
            values={verificationCode}
            setValues={setVerificationCode}
            error={verificationCodeError}
            errorMessage={"Invalid verification code"}
            margin="16px 0 24px 0"
          />
          <Footer>
            <Button
              success
              additionalstyle={`
                width: ${email? '183px': '187px'};
              `}
              onClick={handleVerify}
              data-loading={loading}
            >
              {loading ? null : email? "Verify Email Address": "Verify Phone Number"}
            </Button>
          </Footer>
          <div className="modalText">
            <span>{`Haven’t received the code? `}</span>
            <span
              className='highLight'
              onClick={retry}
            >
              Resend code
            </span>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        type="verification"
        callback={refetch}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleVerify}
        type="verification"
        error={error?.message}
      />
    </>
  );
};

export default ModalVerification;
